import { Component, HostBinding, HostListener, Input, Optional } from '@angular/core';

import { SelectComponent } from '../select.component';

@Component({
  selector: 'frodo-select-option',
  templateUrl: './option.component.html',
  styleUrls: ['./option.component.scss'],
})
export class SelectOptionComponent {
  @Input() value!: string;
  @Input() disabled = false;

  constructor(@Optional() private select: SelectComponent) {}

  @HostBinding('class.select__option') hostClass = true;

  @HostBinding('class.is-selected')
  get isSelected(): boolean {
    return !!this.select && this.select.isValueSelected(this.value);
  }

  @HostListener('click')
  onClick(): void {
    if (!this.select || this.disabled) return;
    this.select.selectValueFromOption(this.value);
  }
}
